module.exports = __webpack_public_path__ + "3d40b9305e6ca5c351f1788bd39583e3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/scala.png
// module id = 379
// module chunks = 1